import React, { FC, lazy } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { GenericObject } from '@dxb-web-ui-framework/common/types';
import { UserAppTransaction } from '@dxb-web-ui-framework/iam/domain/AccessControl/entities';
import { NavigateWithQuery } from '@dxb-web-ui-framework/common/components/NavigateWithQuery/NavigateWithQuery';
import { EligibleRoute, SecureRoute } from '../../../packages/iam/src/components';
import { AccountListProvider } from '../../../packages/account/src/contexts/AccountList/AccountListProvider';
import { ConsolidatedTransactionsProvider } from '../../../packages/transaction/src/contexts/ConsolidatedTransactions';
import { ConsolidatedTransactionDetailsWrapper } from '../../../packages/transaction/src/contexts/ConsolidatedTransactionDetails';
import {
  useSelectedCustomerId,
  useUserInfoIsUserAllowedAction,
} from '../../../packages/userProfile/src/contexts/UserInfo/hooks';

const ConsolidatedTransactionsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "ConsolidatedTransactionsPageComponent" */ '../../../packages/transaction/src/pages/ConsolidatedTransactionsPage'
    ),
);

const ConsolidatedTransactionDetailsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "ConsolidatedTransactionDetailsPageComponent" */ '../../../packages/transaction/src/pages/ConsolidatedTransactionDetailsPage'
    ),
);

const ConsolidatedTransactionsRouter: FC<GenericObject> = ({ brandConfig, requiredEntitlements, logic }) => {
  const location = useLocation();
  const customerId = useSelectedCustomerId();
  const isAllowed = useUserInfoIsUserAllowedAction(requiredEntitlements, logic);

  if (!isAllowed) {
    return <NavigateWithQuery to={`/${customerId}/dashboard`} replace state={{ from: location }} />;
  }

  return (
    <AccountListProvider>
      <ConsolidatedTransactionsProvider>
        <Routes>
          <Route
            path='/*'
            element={
              <SecureRoute requiredEntitlements={UserAppTransaction.FundsTransferHistory}>
                <EligibleRoute>
                  <ConsolidatedTransactionDetailsWrapper>
                    <ConsolidatedTransactionsPage pageConfig={brandConfig.transactionHistoryPage} />
                  </ConsolidatedTransactionDetailsWrapper>
                </EligibleRoute>
              </SecureRoute>
            }
          />
          <Route
            path='/:transactionNo/details'
            element={
              <SecureRoute>
                <EligibleRoute>
                  <ConsolidatedTransactionDetailsWrapper>
                    <ConsolidatedTransactionDetailsPage pageConfig={brandConfig.transactionDetailsPage} />
                  </ConsolidatedTransactionDetailsWrapper>
                </EligibleRoute>
              </SecureRoute>
            }
          />
        </Routes>
      </ConsolidatedTransactionsProvider>
    </AccountListProvider>
  );
};

export { ConsolidatedTransactionsRouter };
